import React from "react";
import AgeConditionGauge from "./AgeConditionGauge";
import PropertyConditionGauge from "./PropertyFeaturesHighlight";
import PropertySummary from "./PropertySummary";
import RoomImprovementGauge from "./RoomImprovementGauge";
import ValueGrowthComparisonChart from "./ValueGrowthComparisonChart";
import PropertySizeComparisonChart from "./PropertySizeComparisonChart";
import InvestmentPotentialCalculator from "./InvestmentPotentialCalculator";
import ValueEstimationChart from "./ValueEstimationChart";
import PropertyConditionCard from "./PropertyConditionCard";
import PropertyLocation from "./PropertyLocation";
import NeighborhoodOverviewCard from "./NeighborhoodOverviewCard";
import DetailedValuationCard from "./DetailedValuationCard";
import ComparableSalesAnalysis from "./ComparableSalesAnalysis";
import MarketIndicatorsDashboard from "./MarketIndicatorsDashboard";
import FinancingInvestmentPotential from "./FinancingInvestmentPotential";
import MicroMarketAnalysis from "./MicroMarketAnalysis";
import RoomClassification from "./RoomClassification";
import ImageScoreTable from "./ImageScoreTable";
import RealEstateChat from "./RealEstateChat";

import { Col, Row } from "antd";
import "./features.css";

function Features() {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const isAdmin = user && user?.is_staff;
  if (!isAdmin) {
    return null;
  }

  return (
    <Row gutter={[16, 16]} style={{ padding: "16px", paddingTop: "40px" }}>
      <Col xs={24} sm={8}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <PropertyConditionGauge />
          </Col>
          <Col span={24}>
            <AgeConditionGauge />
          </Col>
          <Col span={24}>
            <RoomImprovementGauge />
          </Col>
          <Col span={24}>
            <ValueGrowthComparisonChart />
          </Col>
          <Col span={24}>
            <PropertySizeComparisonChart />
          </Col>
          <Col span={24}>
            <InvestmentPotentialCalculator />
          </Col>
          <Col span={24}>
            <ValueEstimationChart />
          </Col>
          <Col span={24}>
            <NeighborhoodOverviewCard />
          </Col>
          <Col span={24}>
            <DetailedValuationCard />
          </Col>
        </Row>
      </Col>
      <Col xs={24} sm={16}>
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <PropertySummary />
          </Col>
          <Col span={24}>
            <PropertyConditionCard />
          </Col>
          <Col span={24}>
            <PropertyLocation />
          </Col>
          <Col span={24}>
            <ComparableSalesAnalysis />
          </Col>
          <Col span={24}>
            <MarketIndicatorsDashboard />
          </Col>
          <Col span={24}>
            <FinancingInvestmentPotential />
          </Col>
          <Col span={24}>
            <MicroMarketAnalysis />
          </Col>
          <Col span={24}>
            <ImageScoreTable />
          </Col>
          <Col span={24}>
            <RoomClassification />
          </Col>
          <Col span={24}>
            <RealEstateChat />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Features;
